<!-- eslint-disable vue/multi-word-component-names -- Icon components are named after the glyph they render. -->
<template>
    <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 20h4L20 8a2.8 2.8 0 0 0-4-4L4 16z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
</template>
